import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { push } from 'react-router-redux';
import { Dropdown } from 'semantic-ui-react';
import {
  SHOWROOM,
} from '../constants/apps';

class DropdownMenu extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    isSiteplan: PropTypes.bool,
    apps: PropTypes.arrayOf(PropTypes.shape({
      appID: PropTypes.string.isRequired,
      webURL: PropTypes.string,
      app: PropTypes.shape({
        shortName: PropTypes.string.isRequired,
      }).isRequired,
    })),
  }

  handleNavigatePage = (e, d) => {
    e.preventDefault();
    const { store } = this.context;
    if (d && d.value) {
      window.location.href = d.value;
    } else {
      store.dispatch(push('/'));
    }
  }

  render() {
    const { isSiteplan, apps } = this.props;
    const appsAccess = apps ? apps.filter((app) => {
      if (isSiteplan) {
        return app.hasAccess && app.appID !== SHOWROOM;
      }
      return app.hasAccess;
    }) : [];

    return (
      <Dropdown
        className="top-menu-dropdown"
        text="Showroom"
        selectOnBlur={false}
      >
        <Dropdown.Menu style={{ zIndex: 60 }}>
          {(Array.isArray(appsAccess) && appsAccess.length > 0) ? appsAccess.map(app => (
            <Dropdown.Item
              name={app.app.shortName}
              key={app.appID}
              value={app.appID === 'showroom' ? null : app.webURL}
              onClick={this.handleNavigatePage}
              active={app.appID === 'showroom'}
            >
              {app.app.shortName}
            </Dropdown.Item>
          )) : null }
        </Dropdown.Menu>
      </Dropdown>
    );
  }
}

export default DropdownMenu;



// WEBPACK FOOTER //
// ./src/components/DropdownMenu.jsx